module.exports = __webpack_public_path__ + "img/P150T_weapon_95.0ca0fcff.png";